import cx from 'classnames';
import { getAgeText, localDatumToDate } from 'mk/common/timeUtils';
import { photoUrl } from 'mk/photo/photoUrl';
import { KidEntity, SexType } from 'mk2/apps/settings/schemas';
import { getGenericAvatar } from 'mk2/apps/users/utils';
import Img from 'mk2/components/Img';
import Link from 'mk2/components/Link';
import React from 'react';
import styles from './KidStageItem.mscss';

interface OwnProps {
    isMobile: boolean;
    kid: KidEntity;
}

class KidStageItem extends React.Component<OwnProps> {

    public render() {
        const { isMobile, kid } = this.props;
        let kidPhotoUrl;
        let kidBigPhotoUrl;
        let kidPhotoWidth;
        let kidPhotoHeight;

        const photoMaxSize = isMobile ? 90 : 120;

        if (kid.photos && kid.photos[0]) {
            kidPhotoUrl = photoUrl(kid.photos[0], 's150x150');
            kidBigPhotoUrl = photoUrl(kid.photos[0], 's1600x1600');
            kidPhotoWidth = kid.photos[0].width;
            kidPhotoHeight = kid.photos[0].height;
            const ratio = kidPhotoWidth / kidPhotoHeight;
            if (kidPhotoWidth > kidPhotoHeight) {
                kidPhotoWidth = photoMaxSize;
                kidPhotoHeight = kidPhotoWidth / ratio;
            } else {
                kidPhotoHeight = photoMaxSize;
                kidPhotoWidth = kidPhotoHeight * ratio;
            }

        } else {
            kidPhotoUrl = getGenericAvatar(150, kid.sex);
            kidBigPhotoUrl = null;
            kidPhotoWidth = photoMaxSize;
            kidPhotoHeight = photoMaxSize;
        }

        const birthDate = localDatumToDate(kid.birthDate);
        const ageText = getAgeText(birthDate);

        return (
            <div className={styles.KidStageItem}>
                <div className={styles.KidStageItem__frame}>
                    {kidBigPhotoUrl ? (
                        <Link
                            className={styles.KidStageItem__link}
                            to={kidBigPhotoUrl}
                        >
                            <Img
                                src={kidPhotoUrl}
                                width={kidPhotoWidth}
                                height={kidPhotoHeight}
                            />
                        </Link>
                    ) : (
                        <Img
                            src={kidPhotoUrl}
                            width={kidPhotoWidth}
                            height={kidPhotoHeight}
                        />
                    )}
                </div>
                <div className={styles.KidStageItem__text}>
                    <p className={cx(styles.KidStageItem__text__name, { [styles['KidStageItem__text__name--boy']]: kid.sex === SexType.Boy, [styles['KidStageItem__text__name--girl']]: kid.sex === SexType.Girl })}>{kid.name}</p>
                    {kid.birthDate && (
                        <p className={styles.KidStageItem__text__birthDate}>{ageText}</p>
                    )}
                </div>
            </div>
        );
    }

}

export default KidStageItem;
